import React from 'react';
import Image from '../../../components/AppImage';

import Button from '../../../components/ui/Button';

const FloorTypeCard = ({ floorType, onEdit, onDuplicate, onDelete, onToggleStatus }) => {
  const formatPrice = (price, unit) => {
    return `$${parseFloat(price)?.toFixed(2)} ${unit}`;
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden transition-all duration-150 hover:shadow-md">
      <div className="relative h-48 bg-muted overflow-hidden">
        <Image
          src={floorType?.thumbnail}
          alt={floorType?.thumbnailAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3 flex gap-2">
          <button
            onClick={() => onToggleStatus(floorType?.id)}
            className={`px-3 py-1 rounded-full text-xs font-medium transition-colors duration-150 ${
              floorType?.isActive
                ? 'bg-success text-success-foreground'
                : 'bg-muted text-text-secondary'
            }`}
          >
            {floorType?.isActive ? 'Active' : 'Inactive'}
          </button>
        </div>
      </div>
      <div className="p-4 space-y-3">
        <div>
          <h3 className="text-lg font-semibold text-text-primary mb-1">
            {floorType?.name}
          </h3>
          <p className="text-sm text-text-secondary line-clamp-2">
            {floorType?.description}
          </p>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-border">
          <div>
            <span className="text-xs text-text-secondary block mb-1">Pricing</span>
            <span className="text-lg font-semibold text-primary">
              {formatPrice(floorType?.price, floorType?.priceUnit)}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-text-secondary">Category:</span>
            <span className="text-xs font-medium text-text-primary">
              {floorType?.category}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 pt-3 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEdit(floorType)}
            iconName="Edit2"
            iconPosition="left"
            iconSize={14}
            className="flex-1"
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDuplicate(floorType)}
            iconName="Copy"
            iconSize={14}
          />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(floorType)}
            iconName="Trash2"
            iconSize={14}
          />
        </div>
      </div>
    </div>
  );
};

export default FloorTypeCard;